import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EventCardContent } from '@datapad/common-controls';
import { useAppContext } from '@datapad/data-model';
import { Event, ExpandLess, ExpandMore } from '@mui/icons-material';
import { Card, CardContent, CardHeader, Collapse, IconButton, Tooltip } from '@mui/material';
import React from 'react';
export function TimelineEventCard(props) {
    const { event, isExpanded, onToggle } = props;
    const appContext = useAppContext();
    const canEdit = appContext.getEffectivePermissionLevel() === 'game-master';
    const handleCalendarLink = React.useCallback(() => {
        appContext.handleCalendarLink(event.date);
    }, [appContext, event.date]);
    const handleToggleClick = React.useCallback((clickEvent) => {
        clickEvent.stopPropagation();
        onToggle();
    }, [onToggle]);
    const handleCardClick = React.useCallback((clickEvent) => {
        clickEvent.stopPropagation();
    }, []);
    return (_jsxs(Card, { elevation: isExpanded ? 8 : 2, sx: {
            minWidth: 250,
            overflow: 'hidden',
            transition: 'elevation 0.2s ease-in-out',
        }, onClick: handleCardClick, children: [_jsx(CardHeader, { title: event.title, titleTypographyProps: {
                    variant: 'subtitle1',
                    align: 'center',
                }, action: _jsx(Tooltip, { title: isExpanded ? 'Close' : 'Expand', children: _jsx(IconButton, { onClick: handleToggleClick, "aria-label": "toggle details", children: isExpanded ? _jsx(ExpandLess, {}) : _jsx(ExpandMore, {}) }) }), sx: { pb: isExpanded ? 0 : undefined } }), _jsx(Collapse, { in: isExpanded, children: _jsx(CardContent, { sx: { textAlign: 'left', pt: 0 }, children: _jsx(EventCardContent, { event: event, showTitle: false, canEdit: canEdit, onDelete: canEdit
                            ? () => appContext.deleteEvent(event)
                            : undefined, additionalActions: _jsx(Tooltip, { title: "View in calendar app", children: _jsx(IconButton, { onClick: handleCalendarLink, "aria-label": "view in calendar", children: _jsx(Event, {}) }) }) }) }) })] }));
}
//# sourceMappingURL=TimelineEventCard.js.map